import cardBarsQuestionDisabled from './images/card-bars-question-disabled.svg';
import cardBarsQuestionPressed from './images/card-bars-question-pressed.svg';
import cardBarsQuestion from './images/card-bars-question.svg';
import documentChecklistDisabled from './images/document-checklist-disabled.svg';
import documentChecklistPressed from './images/document-checklist-pressed.svg';
import documentChecklist from './images/document-checklist.svg';
import documentShieldDisabled from './images/document-shield-disabled.svg';
import documentShieldPressed from './images/document-shield-pressed.svg';
import documentShield from './images/document-shield.svg';
import gearDisabled from './images/gear-disabled.svg';
import gearPressed from './images/gear-pressed.svg';
import gear from './images/gear.svg';
import grid2x2Disabled from './images/grid-2x2-disabled.svg';
import grid2x2Pressed from './images/grid-2x2-pressed.svg';
import grid2x2 from './images/grid-2x2.svg';
import keyDisabled from './images/key-disabled.svg';
import key from './images/key.svg';
import lockXDisabled from './images/lock-x-disabled.svg';
import lockXPressed from './images/lock-x-pressed.svg';
import lockX from './images/lock-x.svg';
import monitorChecklistDisabled from './images/monitor-checklist-disabled.svg';
import monitorChecklistPressed from './images/monitor-checklist-pressed.svg';
import monitorChecklist from './images/monitor-checklist.svg';
import personWarningDisabled from './images/person-warning-disabled.svg';
import personWarningPressed from './images/person-warning-pressed.svg';
import personWarning from './images/person-warning.svg';

/**
 * Icon variants available for sidebar nav rows. Icons are named by shape —
 * `grid2x2`, `lockX`, `key`, etc. — so they can be reused anywhere, not just
 * the nav items they happened to illustrate first.
 */
export type NavIconId =
  | 'grid2x2'
  | 'lockX'
  | 'monitorChecklist'
  | 'key'
  | 'personWarning'
  | 'documentShield'
  | 'cardBarsQuestion'
  | 'documentChecklist'
  | 'gear';

export interface NavIconSet {
  /** Default (white) icon for the enabled, not-active state. */
  default: string;
  /** Pressed/active (orange) icon. Omitted for items that never become active. */
  pressed?: string;
  /** Disabled (grey) icon. Omitted for items that are always enabled. */
  disabled?: string;
}

export const navIcons: Record<NavIconId, NavIconSet> = {
  grid2x2: { default: grid2x2, pressed: grid2x2Pressed, disabled: grid2x2Disabled },
  lockX: { default: lockX, pressed: lockXPressed, disabled: lockXDisabled },
  monitorChecklist: {
    default: monitorChecklist,
    pressed: monitorChecklistPressed,
    disabled: monitorChecklistDisabled,
  },
  key: { default: key, disabled: keyDisabled },
  personWarning: {
    default: personWarning,
    pressed: personWarningPressed,
    disabled: personWarningDisabled,
  },
  documentShield: {
    default: documentShield,
    pressed: documentShieldPressed,
    disabled: documentShieldDisabled,
  },
  cardBarsQuestion: {
    default: cardBarsQuestion,
    pressed: cardBarsQuestionPressed,
    disabled: cardBarsQuestionDisabled,
  },
  documentChecklist: {
    default: documentChecklist,
    pressed: documentChecklistPressed,
    disabled: documentChecklistDisabled,
  },
  gear: { default: gear, pressed: gearPressed, disabled: gearDisabled },
};
